/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { JobsJob } from '../models/jobs-job';
import { Envelope } from '../models/envelope';
import { DTOsCompleteJobRequest } from '../models/dtos-complete-job-request';
import {EngineersJobEngineer} from '@app/modules/operations-api/models/engineers-job-engineer';
@Injectable({
  providedIn: 'root',
})
class JobService extends __BaseService {
  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  JobGetAllResponse(): __Observable<__StrictHttpResponse<Envelope<JobsJob[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/job`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJob[]>>;
      })
    );
  }
  /**
   * @return OK
   */
  JobGetAll(): __Observable<Envelope<JobsJob[]>> {
    return this.JobGetAllResponse().pipe(
      __map(_r => _r.body as Envelope<JobsJob[]>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  JobUpdateResponse(entity: JobsJob): __Observable<__StrictHttpResponse<Envelope<JobsJob>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/job`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJob>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  JobUpdate(entity: JobsJob): __Observable<Envelope<JobsJob>> {
    return this.JobUpdateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<JobsJob>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  JobCreateResponse(entity: JobsJob): __Observable<__StrictHttpResponse<Envelope<JobsJob>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/job`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJob>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  JobCreate(entity: JobsJob): __Observable<Envelope<JobsJob>> {
    return this.JobCreateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<JobsJob>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  JobGetResponse(id: number): __Observable<__StrictHttpResponse<Envelope<JobsJob>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/job/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJob>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  JobGet(id: number): __Observable<Envelope<JobsJob>> {
    return this.JobGetResponse(id).pipe(
      __map(_r => _r.body as Envelope<JobsJob>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  JobDeleteResponse(id: number): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/job/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  JobDelete(id: number): __Observable<Envelope<any>> {
    return this.JobDeleteResponse(id).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }

  /**
   * @param completeJobRequest undefined
   * @return OK
   */
  JobCompleteResponse(completeJobRequest: DTOsCompleteJobRequest): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = completeJobRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/job/complete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param completeJobRequest undefined
   * @return OK
   */
  JobComplete(completeJobRequest: DTOsCompleteJobRequest): __Observable<Envelope<any>> {
    return this.JobCompleteResponse(completeJobRequest).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }

  /**
   * @param params The `JobService.InstallJobCloseParams` containing the following parameters:
   *
   * - `modifiedUser`:
   *
   * - `jobId`:
   *
   * - `closureCode`:
   *
   * @return OK
   */
  JobCloseResponse(params: JobService.JobCloseParams): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.modifiedUser != null) __params = __params.set('modifiedUser', params.modifiedUser.toString());
    if (params.jobId != null) __params = __params.set('jobId', params.jobId.toString());
    if (params.closureCode != null) __params = __params.set('closureCode', params.closureCode.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/job/close`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param params The `JobService.InstallJobCloseParams` containing the following parameters:
   *
   * - `modifiedUser`:
   *
   * - `jobId`:
   *
   * - `closureCode`:
   *
   * @return OK
   */
  JobClose(params: JobService.JobCloseParams): __Observable<{}> {
    return this.JobCloseResponse(params).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @param siteId undefined
   * @return OK
   */
  JobGetForSiteIdResponse(siteId: number): __Observable<__StrictHttpResponse<Envelope<JobsJob[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/job/site/${encodeURIComponent(siteId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJob[]>>;
      })
    );
  }
  /**
   * @param siteId undefined
   * @return OK
   */
  JobGetForSiteId(siteId: number): __Observable<Envelope<JobsJob[]>> {
    return this.JobGetForSiteIdResponse(siteId).pipe(
      __map(_r => _r.body as Envelope<JobsJob[]>)
    );
  }

  /**
   * @param projectId undefined
   * @return OK
   */
  JobGetForProjectIdResponse(projectId: number): __Observable<__StrictHttpResponse<Envelope<JobsJob[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/job/project/${encodeURIComponent(projectId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJob[]>>;
      })
    );
  }
  /**
   * @param projectId undefined
   * @return OK
   */
  JobGetForProjectId(projectId: number): __Observable<Envelope<JobsJob[]>> {
    return this.JobGetForProjectIdResponse(projectId).pipe(
      __map(_r => _r.body as Envelope<JobsJob[]>)
    );
  }

  /**
   * @param taskId undefined
   * @return OK
   */
  JobGetForTaskIdResponse(taskId: number): __Observable<__StrictHttpResponse<Envelope<JobsJob[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/job/task/${encodeURIComponent(taskId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<JobsJob[]>>;
      })
    );
  }
  /**
   * @param taskId undefined
   * @return OK
   */
  JobGetForTaskId(taskId: number): __Observable<Envelope<JobsJob[]>> {
    return this.JobGetForTaskIdResponse(taskId).pipe(
      __map(_r => _r.body as Envelope<JobsJob[]>)
    );
  }
}

module JobService {

  /**
   * Parameters for InstallJobClose
   */
  export interface JobCloseParams {
    modifiedUser: string;
    jobId: number;
    closureCode: number;
  }
}

export { JobService }
